const trapModalFocus = function ($element) {
  $element.on('keydown', function (e) {
    const focusableElements = '*:not([style*="display: none"])button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const focusableContent = $(this).find(focusableElements);
    const firstFocusableElement = focusableContent[0];
    const lastFocusableElement = focusableContent[focusableContent.length - 1];
    const isTabPressed = e.key === 'Tab' || e.keyCode === 9;
    if (!isTabPressed) {
      return;
    }
    if (e.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault();
      }
    }
  });
};

export { trapModalFocus };
